import React from 'react';
import LuxonUtils from '@date-io/luxon';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

function OutlinedDatePicker(props) {
    return (
        <MuiPickersUtilsProvider utils={LuxonUtils}>
            <KeyboardDatePicker
                variant="dialog"
                inputVariant="outlined"
                autoComplete="off"
                format="dd/MM/yyyy"
                clearable
                placeholder="DD/MM/YYYY"
                allowKeyboardControl
                animateYearScrolling={false}
                fullWidth
                {...props}
            />
        </MuiPickersUtilsProvider>
    );
}

export default OutlinedDatePicker;